module.exports = __webpack_public_path__ + "img/robot.96684e73.svg";